import Logo from '../Assests/Logo.png';
import React from "react";
import { FaEnvelope, FaPhoneAlt, FaWhatsapp, FaLinkedin, FaFacebook, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <div style={{ backgroundColor: "#fff", padding: "40px 20px 20px", color: "#000" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
        
        {/* Left Section */}
        {/* <div style={{ color:'#023E62',flex: "1", minWidth: "250px", marginBottom: "20px" }}>    */}
  <div
  style={{
    display: "flex",
    alignItems: "center",
     marginBottom: "50px",
    gap: "8px",
    cursor: "pointer",
    marginLeft: window.innerWidth < 900 ? "10px" : "20px", // xs vs md
  }}
>
  {/* Logo */}
  <img
    src={Logo}
    alt="CA Logo"
    style={{
      height: window.innerWidth < 900 ? "30px" : "50px",
      width: window.innerWidth < 900 ? "70px" : "80px",
    }}
  />

  {/* Firm Name */}
  <div
    style={{
      fontFamily: "Arial, sans-serif",
      fontWeight: "bold",
      fontSize:
        window.innerWidth < 600
          ? "10px"
          : window.innerWidth < 900
          ? "12px"
          : "14px",
      color: "#0C2C4C",
      letterSpacing: "1px",
      textTransform: "uppercase",
      marginRight: window.innerWidth < 900 ? "20px" : "200px",
      lineHeight: 1.4,
    }}
  >
    <div>PDN & ASSOCIATES</div>
    <div>CHARTERED ACCOUNTANTS</div>
  </div>
</div>





        {/* </div> */}

        {/* Middle Section - Links */}
        <div style={{ flex: "1", minWidth: "200px", marginBottom: "20px",marginRight:'30px' }}>
          <h3 style={{color:'#023E62', fontWeight: "bold", marginBottom: "10px" }}>Quick Links</h3>
          <ul style={{ color:'#023E62',listStyle: "none", padding: 0, fontSize: "14px" }}>
            <li style={{ marginBottom: "8px" }}>
  <a href="/" style={{ color: '#02B242', textDecoration: "none" }}>Home</a>
</li>

            <li style={{ marginBottom: "8px" }}>
  <a href="/" style={{ color: '#02B242', textDecoration: "none" }}>About Us</a>
</li>
<li style={{ marginBottom: "8px" }}>
  <a href="/" style={{ color: '#02B242', textDecoration: "none" }}>Our Team</a>
</li>
<li style={{ marginBottom: "8px" }}>
  <a href="/" style={{ color: '#02B242', textDecoration: "none" }}>Contact</a>
</li>

          </ul>
        </div>

        {/* Right Section - Contact */}
        <div style={{ color:'#02B242',flex: "1", minWidth: "250px", marginBottom: "20px" ,marginRight:'-20px'}}>
          <h3 style={{ color:'#023E62',fontWeight: "bold", marginBottom: "10px" }}>Contact Us</h3>
          <p style={{ fontSize: "14px", marginBottom: "10px" }}>
            402, PARAS PEARL, GREEN GLEN LAYOUT
BELLANDUR, BANGALORE-560103
          </p>
          <p style={{ fontSize: "14px" }}>
            <FaEnvelope /> <a href="mailto:INFO@PDNANDASSOCIATES.COM" style={{ color:'#02B242', textDecoration: "none" }}> INFO@PDNANDASSOCIATES.COM</a>
          </p>
          <p style={{ fontSize: "14px" }}>
            <FaPhoneAlt /> <a href="tel:+919606078040" style={{ color:'#02B242', textDecoration: "none" }}>+91 9606078040</a>
          </p>
          <div style={{ display: "flex", marginTop: "10px", gap: "10px" }}>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedin size={24} color="#023E62" /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer"><FaFacebook size={24} color="#023E62" /></a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram size={24} color="#023E62" /></a>
            <a href="https://wa.me/919606078040" target="_blank" rel="noreferrer"><FaWhatsapp size={24} color="#023E62" /></a>
          </div>
        </div>

        
      </div>
            <div style={{ textAlign: 'center', fontSize: '14px',color:'#02B242' }}>
        &copy; {new Date().getFullYear()} PDN & Associates. All rights reserved. 
       
      </div>
    </div>
  );
};

export default Footer;
